import { BigNumber } from 'bignumber.js';

export function fmtAmount(value: BigNumber): string {
  const fractionDigits = Math.min(4, Math.max(2, value.decimalPlaces() ?? 0));
  return value.toFormat(fractionDigits, BigNumber.ROUND_HALF_UP, {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.',
  });
}

export function fmtUsdShort(value: number): string {
  return `$${value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function fmtUsd(value: number | string | null | undefined): string {
  if (value == null) return '—';
  const parsed = new BigNumber(value);
  if (!parsed.isFinite()) return '—';
  return `${parsed.toFormat(2, BigNumber.ROUND_HALF_UP, {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.',
  })} USD`;
}
